(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    const styleShopPayTerms = () => {
    document.querySelectorAll('shopify-payment-terms').forEach((element) => {
      const applyStyles = () => {
        const root = element.shadowRoot;
        if (!root) return;

        root.querySelectorAll('*').forEach((node) => {
          if (node instanceof HTMLElement) {
            node.style.setProperty('color', '#000000', 'important');
            node.style.setProperty('font-weight', '700', 'important');
            node.style.setProperty('opacity', '1', 'important');
          }
        });
      };

      applyStyles();

      if (element.shadowRoot && !element.dataset.shopPayStyleObserver) {
        new MutationObserver(applyStyles).observe(element.shadowRoot, {
          childList: true,
          subtree: true,
        });
        element.dataset.shopPayStyleObserver = 'true';
      }
    });
  };

  customElements.whenDefined('shopify-payment-terms').then(styleShopPayTerms);
  document.addEventListener('shopify:section:load', styleShopPayTerms);
  } catch(e) { console.error(e); }
})();

})();
